import { SxProps } from "@mui/material";

export const sxInputSendRetentionFormFull: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '485px'
}

export const sxBoxSendRetentionForm: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '25px'
}
